/*
 * ASC collection colour swatches - Arrow 2
 * --------------------------------------------------------------
 * Swaps the product section in place when a swatch is clicked,
 * using Shopify's Section Rendering API. Progressive enhancement:
 * each swatch is a real <a> to the product, so if anything fails
 * we fall back to a normal navigation.
 *
 * Loaded once (guarded). Uses event delegation on document so it
 * keeps working after the section is replaced.
 */
(function () {
  if (window.__ascColorSwatchesInit) return;
  window.__ascColorSwatchesInit = true;

  var loading = false;

  function sectionWrapper(id) {
    return document.getElementById('shopify-section-' + id);
  }

  function hardNavigate(url) {
    window.location.href = url;
  }

  async function swap(swatch) {
    var container = swatch.closest('[data-asc-swatches]');
    if (!container) return;

    var sectionId = container.getAttribute('data-section-id');
    var url = swatch.getAttribute('data-url') || swatch.getAttribute('href');
    if (!url || !sectionId) return;

    if (!sectionWrapper(sectionId)) {
      hardNavigate(url);
      return;
    }

    loading = true;
    container.classList.add('is-loading');

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);

    try {
      var res = await fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      var text = await res.text();
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var incoming = doc.getElementById('shopify-section-' + sectionId);

      var current = sectionWrapper(sectionId);
      if (!current) throw new Error('Target section missing');

      // Section Rendering API returns either the wrapped section or just
      // its inner markup - handle both.
      current.innerHTML = incoming ? incoming.innerHTML : text;

      if (history && history.pushState) {
        history.pushState({ ascSwatch: true }, '', url);
      }

      document.dispatchEvent(new CustomEvent('asc:section:swapped', {
        detail: { sectionId: sectionId, url: url }
      }));
    } catch (err) {
      hardNavigate(url);
      return;
    } finally {
      loading = false;
      var c = document.querySelector('[data-asc-swatches]');
      if (c) c.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('[data-asc-swatch]');
    if (!swatch) return;
    e.preventDefault();
    if (loading) return;
    swap(swatch);
  });

  // Restore correct state when navigating back/forward after a swap.
  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
